export const apiURL = {
    GET_LOGINDETAILS: 'api/pbc/postLoginDetails',
    VERIFY_OTP: 'api/pbc/verifyOTP',
    GET_OTP_BY_MOBILE: 'api/pbc/GetOTPByMobileNo',
    GET_PAYMENTSTATUS_BY_ORDERID: 'api/pbc/getTransDetailsByOrderNo',
    GET_DEALS: 'api/auth/dealDetails',
    GET_USER_PROFILE: 'api/auth/getUserProfile',
    GET_INSTALLMENTS: 'api/auth/installmentDetails',
    GET_TRANSACTIONS: 'api/auth/transactionDetails',
    GET_TRANSACTION_RECEIPT: 'api/auth/paymentReceipt',
    CHECK_OUT_DETAILS: 'api/auth/getPayCheckOutDetails',
    UPDATE_EMAIL: 'api/auth/updateEmail',
    LOG_OUT: 'api/auth/logout',
    GET_TOKEN: 'api/auth/get-token',
    GET_TOKEN_BY_SHORT_LINK: 'api/pbc/getTokenByShortLink',
    GET_RECAPTCHA : 'api/pbc/get-captcha-key',
    GET_SESSION_DETAILS: 'api/auth/getSessionDetails',
    VALIDATE_CARD: 'api/pbc/validateCard',
    GET_CREDIT_LIMITS:'api/auth/getLimit',
    GET_TRANS_BY_SESSION_ID: 'api/auth/getTransDetailsBySessionId',
    GET_TRANS_BY_REF_ID: 'api/auth/getTransDetailsByRefId',
    CREATE_KNET_SESSION: 'api/auth/create-session/knet' 
}